import {useQueryParam, StringParam} from 'use-query-params';
import {
  setDynamicLink,
  setCourseTokenValues,
  setCourseInfoValues,
  goToDeviceConfig,
} from './actions';
import {setToken} from 'store/meeting/actions/properties';
import {setMe} from 'store/communication/actions/stateActions';
import {translate} from 'i18n/context/I18nContext';
import {validateWebLaunchToken} from 'utils/validateWebLaunchToken';
import {logEvent} from 'utils/firebase/analytics';
import {truncateFirebaseAnalyticParameterValue} from 'utils/firebase/utils';
import {
  SET_USER_PERMISSIONS,
  INVALID_TOKEN,
} from 'utils/firebase/analytics.config';
import fetchJsonDataOfCourseInfo from 'utils/communication/DownloadCourseInfo';
import {setLocation} from 'store/world/actions';
import {joinMeeting} from 'store/meeting/actions/meeting';

export const initDynamicLinkHandler = (token, avatarSelection = true) => {
  return async (dispatch, getState) => {
    let verifiedToken;
    try {
      verifiedToken = await validateWebLaunchToken(token);
    } catch (error) {
      await dispatch(setDynamicLink(undefined));
      await logEvent(INVALID_TOKEN, {error: 'verified_launch_rejected'});
      return;
    }

    const courseTokenValues = {
      worldToLoad: verifiedToken.worldToLoad,
      courseContentUrl: verifiedToken.courseContentUrl,
      AITeacherToLoad: verifiedToken.AITeacherToLoad,
      userId:
        verifiedToken.userId !== undefined
          ? verifiedToken.userId
          : undefined,
      courseId:
        verifiedToken.courseId !== undefined
          ? verifiedToken.courseId
          : undefined,
      unitId:
        verifiedToken.unitId !== undefined
          ? verifiedToken.unitId
          : undefined,
      unitName: verifiedToken.unitName ?? undefined,
      grade: verifiedToken.grade ?? undefined,
      subject: verifiedToken.subject ?? undefined,
      // Present on every token issued since the course's grade/subject were signed in (QUI-166).
      courseContextVersion: verifiedToken.courseContextVersion ?? undefined,
      courseProgress:
        verifiedToken.courseProgress !== undefined
          ? verifiedToken.courseProgress.progress
          : 0,
      collectEmails:
        verifiedToken.collectEmails !== undefined
          ? verifiedToken.collectEmails
          : false,
      isPromotional:
        verifiedToken.isPromotional !== undefined
          ? verifiedToken.isPromotional
          : false,
      resumeLessonId: verifiedToken.resumeLessonId ?? undefined,
      resumeSlideIndex: verifiedToken.resumeSlideIndex ?? undefined,
      // A course's Start / Continue lands in Quikbase at its portal (launch contract v2): the unit to continue there.
      resumeUnitId: verifiedToken.resumeUnitId ?? undefined,
      launchRoute: verifiedToken.launchRoute ?? undefined,
    };
    (async () => {
      const {data: resultDataCourseInfo} = await fetchJsonDataOfCourseInfo(
        verifiedToken.courseContentUrl,
      );
      dispatch(
        setCourseInfoValues(
          resultDataCourseInfo
            ? {
                ...resultDataCourseInfo,
                teacherName: verifiedToken.AITeacherToLoad, // Because for unit metaverses we want to read teacher to load only from one source and not more
              }
            : resultDataCourseInfo,
        ),
      );
    })();
    dispatch(setLocation(courseTokenValues.worldToLoad));

    dispatch(setCourseTokenValues(courseTokenValues));

    const {error} = verifiedToken;
    if (error) {
      await dispatch(setDynamicLink(undefined));

      if (token) {
        await logEvent(INVALID_TOKEN, {
          error: error,
        });

        console.error(error);
      }
    } else {
      await dispatch(setDynamicLink(token));
      await dispatch(setToken(token));
      if (!avatarSelection) dispatch(goToDeviceConfig());

      const {peerId, permissions, roomId, integration} = verifiedToken;
      const displayName = translate('linkActionsWeb.userNum', {
        num: peerId.substring(0, 4),
      });
      const displayNameSet = false;
      const device = {};
      await dispatch(
        setMe({peerId, displayName, displayNameSet, device, permissions}),
      );

      const permissionsString = permissions.join(' ');
      await logEvent(SET_USER_PERMISSIONS, {
        meeting_id: roomId,
        integration: integration,
        permissions: truncateFirebaseAnalyticParameterValue(permissionsString),
      });
    }
  };
};
